import React, { FC } from 'react';
import {
  ParticularTravelsFiltersFormType,
  ParticularTravelStatus,
  StatusPayment
} from '../../models/particularTravelsModel';
import { ChipModel } from 'shared/components/filters/Chip';
import FilterChipsBar from 'shared/components/filters/FilterChipsBar';
interface ChipBarProps {
  filters: ParticularTravelsFiltersFormType;
  defaultFilters: ParticularTravelsFiltersFormType;
  onFiltersChange: (filters: ParticularTravelsFiltersFormType) => void;
  selectedClientLabel: string;
}
const ChipsBar: FC<ChipBarProps> = ({
  filters,
  defaultFilters,
  onFiltersChange,
  selectedClientLabel
}) => {
  const chips: ChipModel[] = [];
  if (
    filters.dateFrom &&
    filters.dateFrom.format('DD/MM/YYYY HH:mm') !==
      defaultFilters?.dateFrom?.format('DD/MM/YYYY HH:mm')
  ) {
    chips.push({
      label: 'Desde:',
      value: `${filters.dateFrom.format('DD/MM/YYYY HH:mm')}`,
      onDelete: () => onFiltersChange({ ...filters, dateFrom: null })
    });
  }

  if (
    filters.dateTo &&
    filters.dateTo.format('DD/MM/YYYY HH:mm') !==
      defaultFilters?.dateTo?.format('DD/MM/YYYY HH:mm')
  ) {
    chips.push({
      label: 'Hasta:',
      value: `${filters.dateTo.format('DD/MM/YYYY HH:mm')}`,
      onDelete: () => onFiltersChange({ ...filters, dateTo: null })
    });
  }

  if (filters.id) {
    chips.push({
      label: 'ID:',
      value: `${filters.id}`,
      onDelete: () => onFiltersChange({ ...filters, id: '' })
    });
  }

  if (filters.clientId) {
    chips.push({
      label: 'Cliente:',
      value: selectedClientLabel,
      onDelete: () => onFiltersChange({ ...filters, clientId: null })
    });
  }
  if (filters.status_payment) {
    const statusLabel =
      filters.status_payment === StatusPayment.PAID
        ? 'Pagado'
        : filters.status_payment === StatusPayment.PENDING
        ? 'Pendiente'
        : filters.status_payment === StatusPayment.MANUAL_PAYMENT
        ? 'Pagado Manual'
        : 'Impago';
    chips.push({
      label: 'Estado de Pago:',
      value: `${statusLabel}`,
      onDelete: () => onFiltersChange({ ...filters, status_payment: null })
    });
  }

  const isBilling = filters.state === ParticularTravelStatus.FACTURADO;
  chips.push({
    label: 'Facturado:',
    value: isBilling ? 'Sí' : 'No',
    onDelete: () =>
      onFiltersChange({
        ...filters,
        state: isBilling ? false : ParticularTravelStatus.FACTURADO
      })
  });

  if (filters.has_required_bill) {
    const hasRequiredBilling =
      filters.has_required_bill === 'true' ? 'Sí' : 'No';
    chips.push({
      label: 'Factura requerida:',
      value: hasRequiredBilling,
      onDelete: () =>
        onFiltersChange({
          ...filters,
          has_required_bill: null,
          has_send_bill: null
        })
    });
  }

  if (filters.has_send_bill) {
    const hasSendBilling =
      filters.has_send_bill === 'true' ? 'Enviada' : 'Pendiente';
    chips.push({
      label: 'Envío de factura:',
      value: hasSendBilling,
      onDelete: () => onFiltersChange({ ...filters, has_send_bill: null })
    });
  }

  return <FilterChipsBar chips={chips} />;
};

export default ChipsBar;
